import React from 'react';

import type { Theme } from '@material-ui/core';
import { Block } from '../Block';
import { useKlpStyles } from '../Theme/useKlpStyles';
import { getConfig } from '@klpkonsern/appconfig';

declare global {
    interface AppConfigParameters {
        WEBAPP_ENVIRONMENT_TYPE_DISPLAY: string;
    }
}

const indicatorBoxWidth = 80;

const EnvironmentIndicatorStyles = (theme: Theme) => ({
    root: {
        position: 'fixed',
        top: '0px',
        right: -indicatorBoxWidth / 1.4142,
        zIndex: 10000,
        backgroundColor: '#FFC946',
        boxShadow: `0 0 1px ${theme.palette.primary.main}`,
        color: theme.palette.primary.main,
        width: indicatorBoxWidth,
        height: indicatorBoxWidth,
        fontSize: `calc(${indicatorBoxWidth / 6}px) !important`,
        lineHeight: '1 !important',
        fontWeight: 700,
        display: 'flex',
        paddingBottom: '0.25em',
        flexDirection: 'row',
        alignItems: 'flex-end',
        justifyContent: 'center !important',
        transform: 'rotateZ(45deg)',
        transformOrigin: 'right top',
    },
});

export const EnvironmentIndicator = () => {
    const classes = useKlpStyles({}, EnvironmentIndicatorStyles);

    const environmentType = getConfig('WEBAPP_ENVIRONMENT_TYPE_DISPLAY', '');
    if (!environmentType) return null;

    return (
        <Block
            className={classes.root}
            translation={`environment.${environmentType}`}
        />
    );
};
